var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.blockShimmer,{staticStyle:{"--shimmer-color":"#f5f5f5"},attrs:{"height":"300px","width":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }